import clsx from 'clsx';
import React from 'react';

import styles from './styles';

export interface BottomDrawerProps {
  show: boolean;
  className?: string;
}

const BottomDrawerModal: React.FC<BottomDrawerProps> = (props) => {
  return (
    <div className={clsx([
      props.className,
      styles.container,
      { [styles.containerShow]: props.show },
    ])}>
      {props.children}
    </div>
  );
};

export default BottomDrawerModal;
